import { Link } from 'react-router-dom';
import env from '../../config/env.js';
import Logo from './Logo.jsx';
import usePublicSettings from '../../hooks/usePublicSettings.js';

const SOCIAL = [
  { field: 'siteFacebookUrl', label: 'Facebook', d: 'M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z' },
  { field: 'siteInstagramUrl', label: 'Instagram', d: 'M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zm0 3.68A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84zm0 10.16A4 4 0 1 1 16 12a4 4 0 0 1-4 4zm6.41-10.4a1.44 1.44 0 1 0 1.44 1.44 1.44 1.44 0 0 0-1.44-1.44z' },
  { field: 'siteTiktokUrl', label: 'TikTok', d: 'M16.5 3c.3 2.2 1.5 3.6 3.5 3.9v2.5c-1.3.1-2.5-.3-3.6-.9v6.1c0 3.2-2.3 5.4-5.3 5.4-2.9 0-5.1-2-5.1-4.9 0-3 2.3-4.9 5.2-4.7v2.6c-.4-.1-.8-.1-1.1 0-1.1.2-1.8 1-1.7 2.2.1 1.1 1 1.8 2.1 1.7 1.2-.1 1.9-1 1.9-2.4V3h2.7z' },
  { field: 'siteLinkedinUrl', label: 'LinkedIn', d: 'M4.98 3.5A2.5 2.5 0 1 1 5 8.5a2.5 2.5 0 0 1-.02-5zM3 9h4v12H3zM9 9h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.4c0-1.29-.02-2.95-1.8-2.95-1.8 0-2.08 1.4-2.08 2.85V21H9z' },
  { field: 'siteYoutubeUrl', label: 'YouTube', d: 'M23 12s0-3.2-.4-4.74a2.5 2.5 0 0 0-1.76-1.77C19.3 5.09 12 5.09 12 5.09s-7.3 0-8.84.4A2.5 2.5 0 0 0 1.4 7.26C1 8.8 1 12 1 12s0 3.2.4 4.74a2.5 2.5 0 0 0 1.76 1.77c1.54.4 8.84.4 8.84.4s7.3 0 8.84-.4a2.5 2.5 0 0 0 1.76-1.77C23 15.2 23 12 23 12zm-13 3.27V8.73L15.5 12z' },
  { field: 'siteXUrl', label: 'X', d: 'M18.9 2H22l-7.5 8.6L23 22h-6.8l-5-6.5L5.3 22H2l8-9.2L1.5 2h7l4.5 6zM17 20h1.9L7.1 4H5.1z' },
];

function ContactRow({ icon, children }) {
  return (
    <li className="flex items-start gap-2">
      <span aria-hidden className="mt-0.5 text-brand-orange">{icon}</span>
      <span className="text-sm">{children}</span>
    </li>
  );
}

const COLUMNS = [
  {
    heading: 'Information',
    links: [
      { label: 'About Us', to: '/about' },
      { label: 'Contact Us', to: '/contact' },
      { label: 'Support', to: '/support' },
      { label: 'FAQ', to: '/faq' },
      { label: 'Inquiry', to: '/inquiry' },
      { label: 'Sitemap', to: '/sitemap' },
    ],
  },
  {
    heading: 'Customer Service',
    links: [
      { label: 'Warranty Policy', to: '/warranty-policy' },
      { label: 'Return Policy', to: '/return-policy' },
      { label: 'Shipping Policy', to: '/shipping-policy' },
      { label: 'Terms & Conditions', to: '/terms-conditions' },
      { label: 'Privacy Policy', to: '/privacy-policy' },
    ],
  },
  {
    heading: 'My Account',
    links: [
      { label: 'Login', to: '/login' },
      { label: 'Register', to: '/register' },
      { label: 'My Account', to: '/account' },
      { label: 'My Orders', to: '/account/orders' },
      { label: 'Wishlist', to: '/account/wishlist' },
      { label: 'Compare', to: '/account/compare' },
    ],
  },
  {
    heading: 'Products',
    links: [
      { label: 'All Products', to: '/products' },
      { label: 'Deals', to: '/deals' },
      { label: 'New Arrivals', to: '/new-arrivals' },
      { label: 'Brands', to: '/brands' },
      { label: 'Blog', to: '/blog' },
    ],
  },
];

export default function Footer() {
  const { settings } = usePublicSettings();
  const siteName = settings?.siteName || env.APP_NAME;
  const phone = settings?.sitePhone?.trim();
  const email = settings?.siteEmail?.trim();
  const address = settings?.siteAddress?.trim();
  const hours = settings?.siteBusinessHours?.trim();
  const socials = SOCIAL.filter((s) => settings?.[s.field]?.trim());

  return (
    <footer className="bg-brand-600 text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-8 sm:grid-cols-2 sm:py-10 lg:grid-cols-5">
        <div className="sm:col-span-2 lg:col-span-1">
          <Link to="/" aria-label={`${siteName} — Home`} className="inline-block">
            <Logo className="h-12" onDark />
          </Link>
          <p className="mt-3 text-sm leading-relaxed">
            Mobiles, computers, CCTV and networking — sourced and supported locally.
          </p>

          {(phone || email || address || hours) && (
            <ul className="mt-4 space-y-2">
              {address && <ContactRow icon="📍">{address}</ContactRow>}
              {phone && (
                <ContactRow icon="📞">
                  <a href={`tel:${phone.replace(/\s+/g, '')}`} className="hover:text-brand-orange">{phone}</a>
                </ContactRow>
              )}
              {email && (
                <ContactRow icon="✉️">
                  <a href={`mailto:${email}`} className="hover:text-brand-orange">{email}</a>
                </ContactRow>
              )}
              {hours && <ContactRow icon="🕒">{hours}</ContactRow>}
            </ul>
          )}

          {socials.length > 0 && (
            <div className="mt-4 flex flex-wrap gap-2">
              {socials.map((s) => (
                <a
                  key={s.field}
                  href={settings[s.field]}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  title={s.label}
                  className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-brand-orange hover:text-brand-navy"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden="true">
                    <path d={s.d} />
                  </svg>
                </a>
              ))}
            </div>
          )}
        </div>

        {COLUMNS.map((col) => (
          <div key={col.heading}>
            <h4 className="mb-3 font-semibold text-white">{col.heading}</h4>
            <ul className="space-y-1.5 text-sm">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition hover:text-brand-orange">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs">
        <p>© {new Date().getFullYear()} {siteName}. All rights reserved.</p>
        <p className="mt-2">
          by{' '}
          <a
            href="https://finspire.lk/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline-offset-2 hover:text-white hover:underline"
          >
            Finspire
          </a>
        </p>
      </div>
    </footer>
  );
}
